define('views/base/page',['require','jquery','underscore','views/base/view'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _  = require('underscore'),
        View = require('views/base/view');

    var PageView = View.extend({
        region: 'main',
        className: 'page',
        windowResize: false,
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            if (this.windowResize) {
                this._onWindowResize = _.bind(this.onWindowResize, this);
                $(window).on('resize', this._onWindowResize);
            }
        },
        onWindowResize: function() {
            if (this.model) {
                this.model.trigger('resize');
            }
        },
        dispose: function() {
            if (this.disposed) { return; }

            $(window).off('resize', this._onWindowResize);

            View.prototype.dispose.apply(this, arguments);
        }
    });

    return PageView;
});

